// extracted by mini-css-extract-plugin
export default {"projectMemberHeaderContainer":"ProjectMemberTitle_projectMemberHeaderContainer__X7KMJ"};